import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HC_accessibility from 'highcharts/modules/accessibility';
import HC_exporting from 'highcharts/modules/exporting';
import HC_offlineExporting from 'highcharts/modules/offline-exporting';
import HC_exportData from 'highcharts/modules/export-data';
import HC_noData from 'highcharts/modules/no-data-to-display';
import { withStyles, withTheme } from '@material-ui/core';

import DeepMerge from "../../utils/DeepMerge";

HC_accessibility(Highcharts);
HC_exporting(Highcharts);
HC_offlineExporting(Highcharts);
HC_exportData(Highcharts);
HC_noData(Highcharts);

Highcharts.setOptions({
	lang: {
		thousandsSep: ',',
		// export menu item labels
		viewData: "View Data Table",
		downloadPNG: "Download PNG Image"
	}
});

const styles = {
	h4hack: {
		position: "absolute",
		visibility: "hidden"
	},
	rotate: {
		transform: "rotate(90deg)",
	}
};

class Highchart extends Component {
	constructor(props, context) {
		super(props, context);

		let {theme, pngExport, accessibility, noDataMsg, darkTheme, chartConfig} = this.props,
			exportFontStyles = {
				fontSize: "13px",
				fontFamily: "Arial, Helvetica, sans-serif",
				color: theme.palette.text.primary
			};

		chartConfig.accessibility = Object.assign({}, {
			enabled: accessibility || false,
			keyboardNavigation: {
				order: ["chartMenu", "series", "legend"]
			}
		}, chartConfig.accessibility);

		chartConfig.exporting = DeepMerge.merge({
			enabled: pngExport || accessibility || false,
			accessibility: {
				enabled: accessibility || false
			},
			fallbackToExportServer: false,
			// TODO: when we support exporting, either remove this all together or add in what we want to support
			// https://stackoverflow.com/questions/51130861/how-do-i-get-remove-of-data-table-option-from-high-chart-export
			buttons: {
				contextButton: {
					symbol: "menuball",
					menuItems: chartConfig.exporting && chartConfig.exporting.buttons &&
						chartConfig.exporting.buttons.contextButton && chartConfig.exporting.buttons.contextButton.menuItems ?
						chartConfig.exporting.buttons.menuItems : ["viewData", pngExport ? "downloadPNG" : null],
					className: `rotate highcharts-contextbutton ${darkTheme === true ? "highchart-dark-theme" : "highchart-light-theme"}`,
				}
			},
			chartOptions: {
				title: {
					style: exportFontStyles
				},
				chart: {
					backgroundColor: "#fff"
				},
				legend: DeepMerge.merge(
					chartConfig.legend || {},
					{itemStyle: {
						...exportFontStyles,
						...{fontSize: "8px"}
					}}
				),
				plotOptions: {
					series: {
						dataLabels: {
							enabled: true,
							style: {
								...exportFontStyles,
								...{
									fontSize: "7px",
									textOutline: "none",
									fontWeight: "normal"
								}
							}
						}
					}
				},
				time: {
					useUTC: false
				},
				xAxis: [
					DeepMerge.merge(
						chartConfig.xAxis || {},
						{
							offset: 5,
							lineColor:theme.palette.text.primary,
							title: {
								style: exportFontStyles
							},
							labels: {
								y: 25,
								style: {
									...exportFontStyles,
									...{fontSize: "8px"}
								}
							}
						},
						chartConfig.exporting && chartConfig.exporting.chartOptions
							&& chartConfig.exporting.chartOptions.xAxis ? chartConfig.exporting.chartOptions.xAxis : {},
					)
				]
			}
		}, chartConfig.exporting || {});

		if (chartConfig.yAxis) {
			let yAxisOpts = [],
				getAxisOpts = axis => {
					return {
						title: axis.title != "" && axis.title != null ? {
							style: {
								...exportFontStyles,
								...{fontSize: "10px"}
							}
						} : "",
						labels: {
							style: {
								...exportFontStyles,
								...{fontSize: "8px"}
							}
						}
					};
				};

			if (chartConfig.yAxis.length) {
				chartConfig.yAxis.forEach(axis => {
					yAxisOpts.push(DeepMerge.merge(
						axis,
						getAxisOpts(axis)
					));
				});
			} else {
				yAxisOpts.push(DeepMerge.merge(
					chartConfig.yAxis,
					getAxisOpts(chartConfig.yAxis)
				));
			}

			chartConfig.exporting.chartOptions.yAxis = yAxisOpts;
		}

		if (noDataMsg) {
			chartConfig.lang = Object.assign({}, {
				noData: noDataMsg,
			}, chartConfig.lang);

			chartConfig.noData = Object.assign({}, {
				style: {
					color: theme.palette.text.primary,
					fontSize: "1rem",
					fontWeight: 400
				}
			}, chartConfig.noData);
		}
	}

	render() {
		let {chartConfig, classes, id} = this.props;

		return (
			<div id={id}>
				{/* because highcharts starts with h5, so for heiarchy, need hack here */}
				<h4 className={classes.h4hack}><div>hack</div></h4>
				<HighchartsReact
					options={chartConfig}
					highcharts={Highcharts} />
			</div>
		);
	}
}

Highchart.defaultProps = {
	accessibility: true,
	pngExport: false,
	darkTheme: false
};

Highchart.propTypes = {
	theme: PropTypes.object.isRequired,
	chartConfig: PropTypes.object.isRequired,
	classes: PropTypes.object.isRequired,
	pngExport: PropTypes.bool,
	accessibility: PropTypes.bool,
	darkTheme: PropTypes.bool,
	noDataMsg: PropTypes.string,
	id: PropTypes.string
};

export default withStyles(styles)(withTheme(Highchart));
